import { env } from 'src/env';
import { isEnterprise } from 'src/utils';

const FOOTER_LINK = env.REACT_APP_NINJA_SHARED_SIGNUP_URL;

export const Footer = () => {
  return (
    <div className="nj-footer">
      <a
        href={FOOTER_LINK}
        target="_blank"
        rel="noreferrer"
        className="nj-button nj-button--primary"
      >
        {/*todo this is workaround to fix the deployment*/}
        {isEnterprise ? 'Try Ninja' : 'Try Ninja'}
      </a>
      <p>Ninja can make mistakes. Please double check responses.</p>
    </div>
  );
};
